import { emptyFn } from 'utils/function';

import {
  createProjectOption,
  ProjectOption,
  ProjectOptionConfig,
  ProjectOptionParams,
} from './createProjectOption';
import { pick } from 'utils/object';

const optionsCache: Record<string, ProjectOptionConfig & { option: ProjectOption }> = {};

export function registerProjectOption(params: ProjectOptionParams) {
  const option = params.modal ?? params.action;

  if (optionsCache[option]) throw new Error(`Duplicate project option registered ${option}`);

  optionsCache[option] = {
    ...createProjectOption(params),
    option,
  };
}

export function getProjectOptionConfig(option: ProjectOption) {
  const config = optionsCache[option];

  if (!config) throw new Error(`Config for project option ${option} not found`);

  return config;
}

export function useProjectOption(option: ProjectOption) {
  const config = getProjectOptionConfig(option);

  const { action, ...options } = config.useProjectAction();

  return {
    ...pick(config, ['Icon', 'overlay', 'shortcut', 'hidden']),
    ...options,
    action: options.isEnabled ? action : emptyFn,
    getLabel: options.getLabel ?? config.getLabel,
  };
}

export function getProjectOptions() {
  return optionsCache as Record<ProjectOption, ProjectOptionConfig & { option: ProjectOption }>;
}
